import { render, staticRenderFns } from "./hintCard.vue?vue&type=template&id=367df5b6"
import script from "./hintCard.vue?vue&type=script&lang=js"
export * from "./hintCard.vue?vue&type=script&lang=js"
import style0 from "./hintCard.vue?vue&type=style&index=0&id=367df5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports